module.exports = __webpack_public_path__ + "static/media/meetup.103a5557.jpg";